<template>
  <div class="chartComp">
    <div class="toolbar">
      <div class="div_btns">
        <button :class="[activeBtn == 'day'?'btn_orange':'btn_white']" @click="setPeriod('day')">День</button>
        <button :class="[activeBtn == 'week'?'btn_orange':'btn_white']" @click="setPeriod('week')">Неделя</button>
        <button :class="[activeBtn == 'month'?'btn_orange':'btn_white']" @click="setPeriod('month')">Месяц</button>
        <button :class="[activeBtn == 'year'?'btn_orange':'btn_white']" @click="setPeriod('year')">Год</button>
      </div>
      <div class="div_info">
        <span>123: {{orderProceeds.total.end}} руб.</span>
        <span>Возврат: {{orderProceeds.total.return}} руб.</span>
      </div>
      <button :class="['btn_white']" @click="getReport">Скачать Excel</button>
    </div>
    <line-chart
      :labels="orderProceeds.labels"
      :datasets="orderProceeds.datasets"
    />
  </div>
</template>

<script>

export default {
  name: 'chartComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'stat',
      activeBtn: 'day'
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOrdersProceeds`, { params: { period: 'day' } })
  },
  components: {
  },
  computed: {
    orderProceeds: function () {
      let proceeds = this.$store.getters[`${this.moduleName}/getProceeds`]
      return {
        total: proceeds.total,
        labels: proceeds.labels,
        datasets: [
          {
            label: '',
            backgroundColor: '#ff8200',
            data: proceeds.orderEnd
          },
          {
            label: '',
            backgroundColor: '#f87979',
            data: proceeds.orderReturn
          }
        ]
      }
    }
  },
  methods: {
    setPeriod (period) {
      this.activeBtn = period
      this.$store.dispatch(`${this.moduleName}/getOrdersProceeds`, { params: { period: period } })
    },
    getReport () {
      this.$store.dispatch(`${this.moduleName}/getOrdersProceedsReport`, { params: { period: this.activeBtn } })
      // let urlReport = this.$store.getters[`${this.moduleName}/getProceedsReport`];
      // console.log(urlReport)
    }
  }
}
</script>

<style scoped lang="scss">

.chartComp {
  margin: 32px;
}

.toolbar {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto 1fr auto;
  grid-column-gap: 10px;
  margin-bottom: 15px;
  grid-row-gap: 15px;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto auto auto auto;
  grid-column-gap: 10px;
}

.btn_orange {
  width: 100%;
  height: 36px;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ff8200;
  object-fit: contain;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #ffffff;
};
.btn_white {
  width: 100%;
  height: 36px;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ffffff;
  object-fit: contain;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #ff8200;
  border: 2px solid #ff8200;
};

.div_info {
  margin: auto 0;
  text-align: center;
}
.div_info span {
  margin-left: 10px;
}

@media screen and (max-width: 1140px){
  .toolbar {
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
  }
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}
</style>
